<template>
  <div id="app" style="height: 100%">

    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload: this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    // 在用户登录时,获取用户的id
    getUserId(){
			this.$http({
				method:'post',
				url:this.config.baseUrl +'/user/loginUser',
				headers:{
					'Content-type': 'multipart/form-data'
				},
			}).then((res)=>{
				console.log(res)
			})
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.el-menu-left.el-menu {
   height: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue